export type StatusFilter = "all" | "active" | "inactive";

export function matchesStatusFilter(
  isActive: boolean,
  statusFilter: StatusFilter,
): boolean {
  if (statusFilter === "all") return true;
  return statusFilter === "active" ? isActive : !isActive;
}

export function countByStatusFilter<T>(
  items: T[],
  getIsActive: (item: T) => boolean,
): Record<StatusFilter, number> {
  return {
    all: items.length,
    active: items.filter((item) => getIsActive(item)).length,
    inactive: items.filter((item) => !getIsActive(item)).length,
  };
}
